import React, { useCallback, useEffect, useRef, useState } from "react";
import * as classes from "./Search.module.scss";
import { Dropdown, DropdownButton, FormControl } from "react-bootstrap";
import InputGroup from "react-bootstrap/InputGroup";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { navigate } from "gatsby";
import { Sessionstore } from "../../Store/StoreData";
import { requestAudioPermissions } from "mic-check/lib/requestMediaPermissions";
import { getCategories } from "../../services/services";
import { useDispatch, useSelector } from "react-redux";
import mic from "../../assets/icons/mike/mic.png";
import clear from "../../assets/icons/close.svg";
import mic_active from "../../assets/icons/mike/mic_active.gif";
import searchbutton from "../../assets/icons/search.png";
import {
  FailureModalShow,
  SearchCategoryData,
  SetCategoryUpdated,
  SetHeaderValue,
} from "../../Store/Action/Action";
import dropdown from '../../assets/icons/Drop.png';



const Search = () => {
  let dispatch = useDispatch();
  const value = useSelector((state) => state.categoryData);
  const HeaderValue = useSelector((state) => state.HeaderValue);
  const CATEGORY_STATUS = useSelector((state) => state.categoryUpdated);
  const CategoryData = useSelector((state) => state.category);
  let searchRef = useRef(null);
  const { listening, resetTranscript, finalTranscript } =
    useSpeechRecognition();
  const [isVoice, setisVoice] = useState(false);
  const[idvalues, SetidValues] = useState(null)
  const [message, setMessage] = useState("");
  const [categories, setcategories] = useState();
  const MessageConfigure = useCallback(() => {
    setMessage(finalTranscript);
    if (listening) {
      setisVoice(true);
    }
  }, [finalTranscript, listening]);

  useEffect(() => {
    getCategories()
      .then((response) => {
        if (response.data.success) {
          setcategories(response.data.data);
        }
      })
      .catch((error) => {
        dispatch(
          FailureModalShow({
            show: true,
            msg: error.message,
          })
        );
      });
  }, []);

  useEffect(() => {
    MessageConfigure();
  }, [listening, MessageConfigure]);

  const onKeyPressHandler = (e) => {
    if (e.key === "Enter") {
      Homesearch();
    }
  };
  // here if user search empty search its navigating to result page code 
  // const Homesearch = () => {
  //   var find = CategoryData.find((item) =>
  //     window.location.pathname.includes(item.name.toLowerCase())
  //   );
  //   console.log(find, "finnddd");

  //   setisVoice(false);
  //   let ref = isVoice ? finalTranscript : message;
  //   if (find === undefined || ref) {
  //     let searchdata = {
  //       category: null,
  //       classification: null,
  //       deals_check: 0,
  //       // search_term: isVoice ? finalTranscript : message,
  //       search_term: listening ? finalTranscript : message,
  //     };
  //     Sessionstore("SearchData", searchdata);
  //     dispatch(SearchCategoryData(searchdata));
  //     dispatch(SetCategoryUpdated(!CATEGORY_STATUS));
  //     navigate("/result");
  //     // setMessage(searchdata?.search_term);
  //   } else {
  //     console.log("else===");
  //     let searchdata = {
  //       ...value,
  //       search_term: isVoice ? finalTranscript : message,
  //     };
  //     Sessionstore("SearchData", searchdata);
  //     dispatch(SearchCategoryData(searchdata));
  //     dispatch(SetCategoryUpdated(!CATEGORY_STATUS));
  //     // setMessage(searchdata?.search_terms);
  //   }
  // };

  // above code modification done if user search empty serach no fucnction nothing to be done like that modified, if this code not works in 
  //future we can use above code .............
  const Homesearch = () => {
    var find = CategoryData.find((item) =>
      window.location.pathname.includes(item.name.toLowerCase())
    );
    console.log(find, "finnddd");

    setisVoice(false);
    let ref = isVoice ? finalTranscript : message;
    
    // Define the search term
    let searchTerm = listening ? finalTranscript : message;
    
    if (!searchTerm.trim()) { // If search term is empty or just whitespace
      console.log("Search term is empty. Not navigating.");
      return; // Exit the function and don't navigate
    }

    if (find === undefined || ref) {
      let searchdata = {
        category: idvalues,
        classification: null,
        deals_check: 0,
        search_term: searchTerm,
      };
      Sessionstore("SearchData", searchdata);
      dispatch(SearchCategoryData(searchdata));
      dispatch(SetCategoryUpdated(!CATEGORY_STATUS));
      navigate("/result");
    } else {
      console.log("else===");
      let searchdata = {
        ...value,
        search_term: searchTerm,
      };
      Sessionstore("SearchData", searchdata);
      dispatch(SearchCategoryData(searchdata));
      dispatch(SetCategoryUpdated(!CATEGORY_STATUS));
    }
};

 // useEffect(() => {
  //   setTimeout(() => {
  //     if (listening && finalTranscript === "") {
  //       console.log("test");
  //       Homesearch();
  //     }
  //   }, 3000);
  // }, [listening]);
  // console.log(HeaderValue, "HeaderValue=====");
  return (
    <>
      <InputGroup className={classes.globalsearch}>
        {/* <StaticImage
          className={classes.search_icon}
          src="../../assets/icons/search.svg"
          alt="find what you want"
          onClick={() => Homesearch()}
        ></StaticImage> */}
        <DropdownButton
          // id="searchoutLine"
          variant="outline-secondary"
          aria-label="choose your search category."
          aria-hidden="true"
          role="menu"
          title={
            <div className={classes.titleSec}>
                <p
                  aria-label={`${HeaderValue} is selected. choose your search category`}
                >
                  {HeaderValue}
                </p>
               {/*  <i aria-hidden={true} className="material-symbols-outlined">
                  expand_more
                </i> */}
                 <img aria-hidden={true} src={dropdown} style={{ width: "9px", height: "5px", marginLeft: "3px" }} />
            </div>
          }
        >
          <Dropdown.Item
            role="menuitem"
            aria-label="all"
            onClick={() => {
              dispatch(SetHeaderValue("All"));
            }}
            className={classes.topdropdownmwnu}
          >

            All
          </Dropdown.Item>
          {categories?.map((item, index) => (
            <Dropdown.Item
              as="a"
              role="menuitem"
              tabIndex={0}
              aria-posinset={index + 1}
              key={index}
              onKeyPress={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  dispatch(SetHeaderValue(item.category_name));
                  (SetidValues(item.id));
                }
              }}
              onClick={() => {
                dispatch(SetHeaderValue(item.category_name));
                (SetidValues(item.id));
              }}
              className={classes.topdropdownmwnu}
            >
              {item?.category_name}
            </Dropdown.Item>
          ))}
        </DropdownButton>
        <FormControl
        style={{paddingRight:"90px"}}
          value={listening ? finalTranscript : message}
          onChange={(e) => {
            console.log(e.target.value, "valuetarget==");
            listening
              ? setMessage(finalTranscript)
              : setMessage(e.target.value);
          }}
          onKeyPress={onKeyPressHandler}
          className={classes.searchinput}
          //aria-label=" search  Find what you want"
          role='textbox'
          placeholder={
            HeaderValue === "All"
              ? "Find what you want"
              : `Find what you want in ${HeaderValue} `

          }
          id="site-search-submit"

        />
        <div>

          <img
            tabIndex={0}
            aria-label="search"
            role="button"
            onClick={()=>Homesearch()}
            // onKeyDown={(e) => {
            //   if (e.key === " ") {
            //     setMessage("");
            //     if (typeof window !== "undefined") {
            //       document.getElementById("site-search-submit").focus();
            //     }
            //   }
            // }}
            className={classes.search_icon1}
            src={searchbutton}
          />
        </div>

        {message !== "" ? (
          <img
            tabIndex={0}
            aria-label="clear search"
            role="button"
            onClick={() => {
              setMessage("");
              document.getElementById("site-search-submit").focus();
            }}
            onKeyDown={(e) => {
              if (e.key === " ") {
                setMessage("");
                if (typeof window !== "undefined") {
                  document.getElementById("site-search-submit").focus();
                }
              }
            }}
            className={classes.clear_icon}
            src={clear}
          />
        ) : null}
        <audio
          // src="https://www.soundjay.com/buttons/beep-01a.wav"
          id="beep_sounds"
        />
        {/* <div className={classes.mobileMenu}>
          <img className={classes.searchicon} src={searchbutton} />
        </div> */}
        {listening ? (
          <div>
            <img
              role="button"
              className={classes.mic_icon}
              tabIndex="0"
              aria-label="voice search"
              // aria-title="voice search"
              src={mic_active}
              alt="microphone"
              onClick={resetTranscript}
              onChange={(e) => {
                setMessage(listening ? finalTranscript : e.target.value);
              }}
            />
          </div>
        ) : (
          <img
            role="button"
            className={classes.mic_icon}
            tabIndex="0"
            aria-label="voice search"
            // aria-title="voice search"
            src={mic}
            onChange={(e) => {
              setMessage(listening ? finalTranscript : e.target.value);
            }}
            alt="microphone"
            onClick={() => {
              if (typeof window !== "undefined") {
                let sound = document.getElementById("beep_sounds");
                sound.play();
                requestAudioPermissions()
                  .then((response) => {
                    if (response) {
                      SpeechRecognition.startListening();
                    }
                  })
                  .catch((error) => {
                    dispatch(
                      FailureModalShow({
                        show: true,
                        msg: "To search by voice, ensure that your microphone is connected properly. Check your settings and get started",
                      })
                    );
                  });
              }
            }}
          />
        )}
      </InputGroup>
    </>
  );
};

export default Search;